import BlockContent from '@sanity/block-content-to-react';

export default function BlockSerializer(props: any) {
  // const { node, children } = props;

  // if (node.style === 'reference') {
  //   return (
  //     <p className="italic text-xs" style={{ marginTop: '8px', marginBottom: '8px' }}>
  //       {children}
  //     </p>
  //   );
  // }

  return BlockContent.defaultSerializers.types.block(props);
}
